import styled from "@emotion/styled";
import React from "react";
import { Field, useForm } from "react-final-form";
import { OnBlur, OnChange } from "react-final-form-listeners";
import ChipArray from "src/components/ChipArrayV2/ChipArray";

const isEmailAddress = (email: string) => {
  var pattern = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
  return pattern.test(email); // returns a boolean
};

interface EmailFieldProps {
  name: string;
  label: string;
}

const FieldContainer = styled.div`
  background-color: var(--app-color-secondary5);
  border-radius: 8px;
  width: 100%;
  display: flex;
  gap: 0;
  flex-wrap: wrap;
  margin-bottom: 1rem;
  & > input {
    flex-grow: 1;
    border: none;
    background-color: transparent;
    padding: 8px;
    &:focus {
      outline: none;
    }
  }
`;

export const Label = styled.label`
  font-size: 12px;
  font-weight: 700;
  color: $app-color-white;
`;

export const EmailField = ({ label, name }: EmailFieldProps) => {
  const form = useForm();
  const auxName = `${name}Aux`;
  const parseEmails = (value, force = false) => {
    if (value) {
      if (!value.match(/[,\s]$/) && !force) {
        return;
      }
      var emails = value.split(/[,\s]/).filter(x => isEmailAddress(x));
      if (emails.length) {
        emails.forEach(x => form.mutators.push(name, x));
        form.mutators.clear(auxName);
      }
    }
  };
  return (
    <>
      <Label>{label}</Label>
      <FieldContainer>
        <ChipArray name={name} />
        <Field
          type="text"
          name={auxName}
          component="input"
          autoComplete="disabled"
          placeholder=""
          onKeyDown={event => {
            if (event.key === "Enter") {
              event.preventDefault();
              parseEmails(event.target.value, true);
            }
          }}
        />
        <OnBlur name={auxName}>
          {() => {
            const value = form.getFieldState(auxName).value;
            parseEmails(value, true);
          }}
        </OnBlur>
        <OnChange name={auxName}>
          {value => {
            parseEmails(value);
          }}
        </OnChange>
      </FieldContainer>
    </>
  );
};
